import React from 'react';
import { getTemplateVariables } from '../lib/customCommands';

interface TemplateVariablesHelpProps {
  isOpen: boolean;
  onClose: () => void;
}

const TemplateVariablesHelp: React.FC<TemplateVariablesHelpProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const templateVariables = getTemplateVariables();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-black border-2 border-white p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">Template Variables</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <i className="fa-solid fa-times text-xl"></i>
          </button>
        </div>

        <div className="mb-4">
          <p className="text-gray-300 mb-4">
            Use these variables in your response messages to make them dynamic. 
            Variables will be replaced with actual values when the command is triggered.
          </p>
        </div>

        <div className="space-y-3">
          {templateVariables.map(({ variable, description }) => (
            <div key={variable} className="border-2 border-dashed border-gray-600 p-3 hover:border-gray-400 transition-colors">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <code className="text-green-400 font-mono text-sm bg-gray-900 px-2 py-1 rounded">
                    {variable}
                  </code>
                  <p className="text-gray-300 text-sm mt-1">{description}</p>
                </div>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(variable);
                  }}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                  title="Copy to clipboard"
                >
                  <i className="fa-solid fa-copy"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 border-2 border-yellow-600 bg-yellow-900 bg-opacity-20 p-4">
          <h3 className="text-yellow-400 font-bold mb-2">
            <i className="fa-solid fa-lightbulb mr-2"></i>
            Examples
          </h3>
          <div className="space-y-2 text-sm">
            <div>
              <p className="text-gray-300">
                <strong>Input:</strong> <code className="text-green-400">Hello {'{senderUsername}'}, the time is {'{currentTime}'}!</code>
              </p>
              <p className="text-gray-400">
                <strong>Output:</strong> Hello @viewer123, the time is 14:30!
              </p>
            </div>
            <div>
              <p className="text-gray-300">
                <strong>Input:</strong> <code className="text-green-400">{'{senderUsername}'} rolled a {'{randomNumber}'}!</code>
              </p>
              <p className="text-gray-400">
                <strong>Output:</strong> @viewer123 rolled a 42!
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="paint-button"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateVariablesHelp;